import { itemPages } from '../../../config/constantLists'
const DashboardLayout = () => import('../../../layouts/DashboardLayout.vue')
const Jockeys = () => import('./views/Jockeys')
const JockeyView = () => import('./views/JockeyView')

export default [
  {
    path: '/jockeys',
    component: DashboardLayout,
    meta: { auth: true },
    children: [
      {
        path: '',
        name: 'contributor.jockeys',
        meta: { auth: true },
        component: Jockeys
      },
      {
        path: 'view/:id?',
        name: 'contributor.jockeyView',
        meta: { auth: true, currentPage: itemPages.view },
        component: JockeyView,
        props: true
      },
      {
        path: 'create',
        name: 'contributor.jockeyCreate',
        meta: { auth: true, currentPage: itemPages.create },
        component: JockeyView
      },
      {
        path: 'update/:id?',
        name: 'contributor.jockeyUpdate',
        meta: { auth: true, currentPage: itemPages.update },
        component: JockeyView,
        props: true
      }
    ]
  }
]
